// Libraries
import classNames from 'classnames';
// Types
import Info from '../Info/Info';
import FormInputProps from './FormInputProps';
import styles from './FormInput.module.scss';
import { Controller } from 'react-hook-form';
import { getFieldValueByDynamicKey } from '@shared/helpers/objectHelper';
import Editor from 'react-simple-wysiwyg';
import CurrencyInput from 'react-currency-input-field';
import { formatDate } from '@shared/helpers/dateHelper';
import FormInputField from './FormInputField';

const FormInput = (props: FormInputProps) => {
  const {
    id,
    type = 'text',
    name,
    label,
    ariaLabel,
    required = false,
    info,
    placeholder,
    classes,
    isDisabled,
    infoClasses,
    readonly,
    control,
    onBlur,
    onEnter,
    suffix,
    prefix,
    precision,
  } = props;

  return (
    <Controller
      name={name}
      control={control}
      render={(e: any) => {
        const errors = e.formState.errors;
        const error = Object.keys(errors).length > 0 ? getFieldValueByDynamicKey(errors, name) : { message: null };

        const commonInfo = !!info && (
          <Info tooltipId={name + id} classes={classNames('input__info', infoClasses)}>
            {info}
          </Info>
        );

        if (type === 'markdown')
          return (
            <div className={classNames('input', classes)} data-status={!!error?.message ? 'error' : ''}>
              <div data-color-mode="light">
                {label && (
                  <span className="input__label-text">
                    {label} {required && '*'} {commonInfo}
                  </span>
                )}
                <Editor
                  containerProps={{ style: { minHeight: '300px', resize: 'vertical' } }}
                  value={e.field.value}
                  onChange={e.field.onChange}
                />
                {!!error?.message && (
                  <span className={styles.error}>
                    <Info place="left" tooltipId={'error' + name + id}>
                      {error?.message}
                    </Info>
                  </span>
                )}
              </div>
            </div>
          );
        var value = e.field.value;
        if (type === 'date') {
          value = value ? formatDate(value, undefined, 'YYYY-MM-DD') : undefined;
        }

        if (!suffix && !prefix) {
          return (
            <FormInputField
              {...props}
              ref={e.field.ref}
              value={value}
              onChange={e.field.onChange}
              error={error?.message}
            />
          );
        }

        return (
          <div className={classNames('input', classes)} data-status={!!error?.message ? 'error' : ''}>
            <label className="input__label">
              {label && (
                <span className="input__label-text">
                  {label} {required && '*'} {commonInfo}
                </span>
              )}

              <CurrencyInput
                key={name}
                ref={e.field.ref}
                id={id}
                aria-label={ariaLabel}
                name={name}
                readOnly={readonly}
                className={classNames('input__field', styles.input)}
                style={{
                  height: type === 'color' ? 50 : 'auto',
                  padding: type === 'color' ? '0 20px' : undefined,
                }}
                onValueChange={(value) => {
                  e.field.onChange(value);
                }}
                onKeyDown={(event) => {
                  if (event.key === 'Enter' && !!onEnter) {
                    onEnter(event);
                  }
                }}
                onBlur={onBlur}
                placeholder={placeholder}
                disabled={isDisabled}
                value={typeof e.field.value === 'number' ? e.field.value.toString() : e.field.value}
                prefix={prefix}
                suffix={suffix}
                decimalSeparator="."
                groupSeparator=""
                decimalsLimit={precision}
              />
              {!!error?.message && (
                <span className={styles.error}>
                  <Info place="left" tooltipId={'error' + name + id}>
                    {error?.message}
                  </Info>
                </span>
              )}
            </label>
          </div>
        );
      }}
    />
  );
};

export default FormInput;
